<style src="./Board.scss" lang="scss"></style>
<template>
  <section class="board">
    <content-header />

    <section class="form-box row">
      <section class="row">
        <event-filter
          @submit-filter="searchSubmit" />
      </section>
    </section>

    <section class="form-box list-box row">
      <board-details
        ref="boardDetails"
        :board="filters.selectedBoard"/>
    </section>
  </section>
</template>

<script>
  import { Dropdown, Datebox, Textbox } from '@/components/primitives'
  import ContentHeader from '@/components/foundation/content-header/ContentHeader'
  import { BoardDetails } from './components'
  import EventFilter from './components/event-filter/EventFilter'

  export default {
    name: 'Board',
    components: {
      ContentHeader,
      EventFilter,
      BoardDetails,
      Dropdown,
      Datebox,
      Textbox
    },
    data () {
      return {
        filters: {
          searchText: '',
          selectedBoard: '',
          startDate: '',
          endDate: '',
          suspendedNoDate: false,
          suspendedWithDate: false,
          reproved: false,
          canceled: false,
          modalities: {}
        },
        form: {
          selectedBoard: '',
          boards: [],
          modalities: [],
          selectedModalities: {}
        }
      }
    },
    methods: {
      searchSubmit ({ form, list }) {
        this.filters = { ...form }
        this.form.selectedBoard = list.selectedBoard
        this.filters.selectedBoard = list.selectedBoard
        this.form.boards = list.boards
        this.filters.modalities = { ...list.selectedModalities }
        this.$refs.boardDetails.resetPaginator()
        const filters = { ...this.filters }
        this.$store.commit('Board/SET_FILTER', filters)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/view/board/Board.vue